export { ChatTabBarIcon } from './ChatTabBarIcon';
